import React from 'react';

function ToolsPolicy() {
    return (
        <div className="p-8 max-w-3xl mx-auto">
            <h1 className="text-2xl font-bold mb-4">326 Tools – Privacy Policy</h1>
            <p className="text-sm text-gray-600">Privacy policy coming soon.</p>
        </div>
    );
}

export default ToolsPolicy;
